import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    RenterTypeList: [],
};

const ownershipSlice = createSlice({
  name: "ownershipSlice",
  initialState,
  reducers: {
    RenterTypeListAction: (state, action) => {
      state.RenterTypeList = action.payload.RenterTypeList;
    },
     resetStateOwnershipAction: () => initialState,
  },
});

export const {
    RenterTypeListAction,
    resetStateOwnershipAction
} = ownershipSlice.actions;

export default ownershipSlice.reducer;
